export class RmnRegion {
  id: number;
  name: string;
  acronym: string;
  selected: boolean;
  description: string;
}
